import React, { useEffect, useState } from 'react'
import io from 'socket.io-client'
import { PageWrapper } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import InitialForm from '../../components/page-components/apps/find-available-estimators/initial-form'
import Loading from '../../components/page-components/apps/find-available-estimators/loading'
import Error from '../../components/page-components/apps/find-available-estimators/error'
import EstimatorList from '../../components/page-components/apps/find-available-estimators/estimator-list'
import { CONST_IO } from '../../constants/general'
import { REDUX_CONST } from '../../redux/constants'
const FindAvailableEstimators = () => {
	const dispatch = useDispatch()
	const [showForm, setShowForm] = useState(true)
	const availableEstimatorsRdx = useSelector(
		(state) => state.getAvailableEstimators,
	)
	const { data, loading, error } = availableEstimatorsRdx

	useEffect(() => {
		if (error || loading || data?.length === 0) {
			setShowForm(true)
		} else setShowForm(false)

		return () => {}
	}, [error, data, loading])

	useEffect(() => {
		// io('http://localhost:5000')
		// Connect to the Socket.IO server
		// Replace 'http://localhost:5000' with your server's URL
		//const socket = io('http://localhost:5000', { transports: ['websocket'] })
		const socket = io('https://www.nvoqe.com', { transports: ['websocket'] })
		// Setup event listeners

		socket.on(CONST_IO.events.WORKER_READY, (data) => {
			if (data.action === CONST_IO.actions.FIND_AVAILABLE_ESTIMATORS) {
				const { message, data: newRows } = data.payload

				dispatch({
					type: REDUX_CONST.appConstants.getAvailableEstimators.success,
					payload: {
						message,
						data: newRows, // immediately populate your table
					},
				})
			}
		})

		// Clean up the effect
		return () => socket.disconnect()
	}, [])

	const showFormHandler = () => {
		setShowForm((prev) => !prev)
	}
	return (
		<PageWrapper showNavigation={false}>
			<InitialForm showForm={showForm} onShowForm={showFormHandler} />
			{loading && <Loading />}
			{data && <EstimatorList data={data} />}
			{error && <Error error={error} />}
		</PageWrapper>
	)
}

export default FindAvailableEstimators
